/*
 *
 * CoursesDetail constants
 *
 */

export const FLUSH_STATE = 'app/CoursesDetail/FLUSH_STATE';

export const LOAD_COURSE = 'app/CoursesDetail/LOAD_COURSE';
export const LOAD_COURSE_SUCCESS = 'app/CoursesDetail/LOAD_COURSE_SUCCESS';
export const LOAD_COURSE_ERROR = 'app/CoursesDetail/LOAD_COURSE_ERROR';